/* eslint-disable eqeqeq */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-explicit-any */

import axios from 'axios';
import { getStorege } from '../../../helpers/db_storage';

import { getToken } from '../../../providers/use-signin';

let dataLocation = getStorege('@mais/delivery/dataStateCity');

const api = axios.create(
  process.env.REACT_APP_PRODU == 'true'
    ? { url: '/' }
    : {
        baseURL: process.env.REACT_APP_URL_API,
      },
);

api.defaults.withCredentials = true;

api.interceptors.request.use(async (config: any) => {
  const token = await getToken();

  config.headers.Authorization =
    'Basic bWFpc2RlbGl2ZXJ5cm9ib3Byb2Q6RjNVZGFzd2lDOHVwUlVYb2ZSaUI=';

  config.data.idOrigem = 9;
  config.data.versaoApp = '9.9.8';

  if (typeof config.data.dsCidade != 'undefined') {
    dataLocation = getStorege('@mais/delivery/dataStateCity');
  }

  config.data.dsCidade = config.data.dsCidadeV2 || dataLocation?.dsCidade;

  if (token && token != 'null') config.headers['Api-Token'] = JSON.parse(token);

  return config;
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.data?.data?.message)
      return Promise.reject(error.response.data.data?.message);
    return Promise.reject(error);
  },
);

export { api };
